import { Divider } from '@mui/material'
import FooterSite from '@/components/common/footer/Site'
import FooterLogosLinks from '@/components/common/footer/FooterLogosLinks'

interface FooterProps {
  menuData?: any
}

export default function Footer({ menuData }: FooterProps) {
  const footerNavMenuItems = menuData?.navigationMenus?.find((m: any) => m.name === 'Footer')?.items || []

  return (
    <footer>
      <Divider />
      <FooterSite footerNavMenuItems={footerNavMenuItems} />
      <Divider />
      <FooterLogosLinks />
    </footer>
  )
}
